import * as actions from './actionTypes'
//点击日历日期
export const go=(flag)=>({
  type:actions.GO,
  flag
})

